import { usePost, UsePostParams } from '../../../../api';
import { useCallback } from 'react';
import { USER_MANAGEMENT_BASE_URL } from '../consts';
import { User } from '../../types/User';

interface UnmatchUsersPayload {
    usersGuids: User['guid'][];
}

type UseUnmatchUsersResponse = UnmatchUsersPayload;

interface UnmatchUsersErrorResponse {
    error: string;
}

type UseUnmatchUsersParams = UsePostParams<UnmatchUsersPayload, UseUnmatchUsersResponse, UnmatchUsersErrorResponse>;

export const useUnmatchUsers = (params: UseUnmatchUsersParams) => {
    const { post, ...rest } = usePost(params);

    const unmatchUsers = useCallback(
        (usersGuids: User['guid'][]) =>
            post(`${USER_MANAGEMENT_BASE_URL}/unmatchUsers`, {
                usersGuids
            }),
        [post]
    );

    return {
        ...rest,
        unmatchUsers
    };
};
